import { createAction } from 'redux-actions';

export const SET_EVERY_TRAVEL_CART = 'SET_EVERY_TRAVEL_CART';

export interface SetEveryTravelCart {
	cartId: number;
}

export const setEveryTravelCartIdAction = createAction<SetEveryTravelCart>(SET_EVERY_TRAVEL_CART);
